import * as Yup from 'yup';
import { linksEncuestasFormModel } from './linksEncuestasFormModel';

const {
    formField: {
        name,
        description,
        surveyId,
        userId,
        fechaEvento,
        nombreEvento,
        nombreCliente,
        telefonoCliente,
        emailCliente,
        diaNacimiento,
        mesNacimiento,
        shareTemplate
    }
} = linksEncuestasFormModel;

export const validationSchema = Yup.object().shape({
    [name.name]: Yup.string().required(name.requiredErrorMsg),
    [description.name]: Yup.string().required(description.requiredErrorMsg),
    [surveyId.name]: Yup.object().nullable().required(surveyId.requiredErrorMsg),
    [userId.name]: Yup.object().nullable().required(userId.requiredErrorMsg),
    [fechaEvento.name]: Yup.string().nullable(),
    [nombreEvento.name]: Yup.string().nullable(),
    [nombreCliente.name]: Yup.string().nullable(),
    [telefonoCliente.name]: Yup.number().typeError(telefonoCliente.invalidErrorMsg).nullable(),
    [emailCliente.name]: Yup.string().email(emailCliente.invalidErrorMsg).nullable(),
    [diaNacimiento.name]: Yup.number().typeError('El día de nacimiento debe ser un número').integer('El día de nacimiento debe ser un número entero').min(1, 'El día mínimo es 1').max(31, 'El día máximo es 31').nullable(),
    [mesNacimiento.name]: Yup.number().typeError('El mes de nacimiento debe ser un número').integer('El mes de nacimiento debe ser un número entero').min(1, 'El mes mínimo es 1').max(12, 'El mes máximo es 12').nullable(),
    [shareTemplate.name]: Yup.object().nullable()
});
